<template>
  <div>
    <Carousel
      v-if="getInfoSimple && getInfoSimple.length > 0"
      :autoplay="true"
      :autoplayTimeout="5000"
      :pagination-enabled="false"
      :loop="true"
      :perPage="1">
      <Slide v-for="(item, idx) in getInfoSimple" :key="idx">
        <a @click="goAd(item)">
          <img class="bannerImg" :src="item.image">
        </a>
      </Slide>
    </Carousel>
    <div v-else-if="getInfoSimple && getInfoSimple.length === 0" class="banner module notranslate" id="bannerDiv" @click="toLocalInfo">
      <div class="remTest" id="innerDiv">
        <div class="subTitle" id="bannerSub">{{getTitle}}</div>
        <div class="mainTitle" id="bannerMain">{{locale.banner_title}}  ></div>
        <div class="subTitle">#{{locale.localinfo_tourist_attraction}} #{{locale.localinfo_cafe}} #{{locale.localinfo_restaurant}}</div>
      </div>
      <button @click.stop="closeBanner" id="closeBanner" class="closeBanner"></button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'Banner',
  data () {
    return {
      getInfoSimple: false
    }
  },
  components: {
    Carousel,
    Slide
  },
  props: [
    'locale',
    'lang'
  ],
  async mounted () {
    const status = this.getAuthInfo.status
    if (status) {
      this.getInfoSimple = await this.$store.dispatch('localinfo/getInfoSimple', status)
    }
  },
  computed: {
    ...mapGetters({
      getTitle: 'common/getTitle',
      ln: 'common/getLang',
      getAuthInfo: 'authentication/getAuthInfo'
    }),
    dgb () {
      return this.$store.state.common.dgb
    }
  },
  methods: {
    toLocalInfo () {
      this.$gtag.event('fromBannerToLocalInfo')
      const hasDgb = this.dgb.name !== 'localinfo'
      const dgbPage = this.dgb.page
      const lang = this.lang
      const ln = this.ln
      const name = hasDgb ? 'page' : 'localinfo'
      const meta = hasDgb ? 'dgb' : null
      const params = function () {
        if (hasDgb) {
          return {
            id: dgbPage,
            lang: lang,
            ln: ln
          }
        } else {
          return {
            ln: ln
          }
        }
      }
      const routerPush = {
        name: name,
        params: params(),
        meta: meta
      }
      this.$router.push(routerPush)
    },
    goAd (item) {
      window.event.preventDefault()
      this.$gtag.event('click', {
        event_category: 'ad',
        event_label: `${item.adName}-${item.adId}`
      })
      window.location.href = item.link
    },
    closeBanner () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.bannerImg {
  width: 100%;
}
.banner{
  position: relative;
  background-image: url('~@/assets/img/banner_back.png');
  background-repeat: no-repeat;
  background-size: contain;
  margin-bottom: 0.2rem;
  height: 19.3vw;
  line-height:2.9vw;
  cursor: pointer;
  transition: all .5s ease;
}
.remTest{
  position: absolute;
  color: #ffffff;
  top: 4vw;
  left: 8vw;
  font-size: 2.5vw;
}
.mainTitle{
  font-weight: 1000;
  color: yellow;
  font-size: 3.7vw;
  padding-bottom: 2vw;
}
.subTitle{
  opacity: 0.9;
  font-weight: 800;
  padding-bottom: 1.5vw;
}
.closeBanner{
  padding: 12px;
  position: absolute;
  opacity: 0.8;
  display: flex;
  align-items: center;
  top: 1.5vw;
  right: 3vw;
}
.closeBanner:before, .closeBanner:after {
  position: absolute;
  content: ' ';
  height: 15px;
  width: 2px;
  background-color: #ffffff;
}
.closeBanner:before {
  transform: rotate(45deg);
}
.closeBanner:after {
  transform: rotate(-45deg);
}
</style>
